export default __webpack_public_path__ + "static/media/img-0409-austria-full-face.de6b3003.png";